import { render, staticRenderFns } from "./MyGy1.vue?vue&type=template&id=910e915c&"
import script from "./MyGy1.vue?vue&type=script&lang=js&"
export * from "./MyGy1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports